<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Add treatment from past visit
        v-col(cols="1" align="right")
          v-btn(icon @click="showDialog = false" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      v-row(no-gutters)
        v-col.pr-4(cols="8")
          template(v-if="isFetching")
            v-skeleton-loader(type="list-item-three-line@5")
          template(v-else)
            div.text-sm.neutral700--text Choose which visit you want select treatment from
            //- v-text-field.text-sm.round-xl.mt-2(v-model="itemName" dense placeholder="Type in item name, uom or group name" outlined hide-details="auto" clearable append-icon="mdi-magnify" @input="searchStart")
            //-   template(v-slot:append)
            //-     v-icon.small.mr-2 mdi-magnify
            v-row.mt-2(no-gutters)
              v-col(cols="4")
                y-select(v-model="selectedVisit" :items="histories" item-text="title" item-value="lead_pid" placeholder="Select visit" small @change="selectVisit(selectedVisit)")
            v-data-table.mt-4(v-model="selected" :headers="headers" :items="treatments" item-key="id" :items-per-page="pageSize" :loading="isFetching" fixed-header :height="treatmentTableHeight" disable-sort hide-default-footer loader-height="2" show-select)
              template(v-slot:header.data-table-select="{ props }")
                yc-checkbox(:input-value="allSelected" :indeterminate="props.indeterminate" :disabled="treatments.length === 0 || allDisabled" @change="handleSelectAll")
              template(v-slot:item.data-table-select="{ item, select, isSelected }")
                yc-checkbox(:input-value="isSelected" :disabled="item.disabled" @change="select($event)")
              template(v-slot:item.name="{ item }")
                .py-4
                  .text-xs.font-medium(:class="[{'neutral500--text': item.hasError}, {'danger500--text': item.product.inventory_enabled && item.stocks <= 0}]") {{ item.name }}
                  .text-xxs.danger500--text(v-show="item.hasError") {{ item.errorMessage }}
              template(v-slot:item.stocks="{ item }")
                .text-xs.font-medium(:class="[{'danger500--text': item.stocks <= 0}]") {{ item.stocks }}
              template(v-slot:item.price_range="{ item }")
                template(v-for="(price, idx) in item.product.price_range")
                  span.text-xs.font-medium(:key="`pr-${idx}`") {{ price | displayPrice($currency) }}
                    span.mx-1(v-if="item.product.price_range.length > 1 && !idx") -

        v-col
          v-card.border.rounded-lg.pa-6.height-adjustment(outlined :style="{ '--selected-item-height': selectedItemHeight }")
            v-row(no-gutters)
              v-col
                .text-sm.font-semibold Selected item
              v-spacer
              v-col.d-flex.justify-end(v-if="selected.length > 0")
                v-btn.button-xs.neutral700--text.underline.mr-1(text @click="handleRemoveAllItem") Remove all
            .selected-items-container.mt-2
              template(v-if="selected.length === 0")
                v-card.px-4.py-8.mt-8.border-dashed(outlined)
                  .d-flex.flex-column.align-center.justify-center.text-center
                    v-icon.mb-6(size="30") $yzi-colors
                    .text-md.font-semibold.mb-1 No items selected
                    .text-sm Any selected items from your list will show up here.
              template(v-else)
                div(v-for="(selectedItem, selectedItemIdx) in selected" :key="selectedItemIdx")
                  v-row.pa-2.align-center(no-gutters)
                    v-col(cols="2")
                      .text-sm {{ selectedItemIdx + 1 }}
                    v-col.mx-2
                      .text-sm {{ selectedItem.name }}
                    v-col.d-flex.justify-end(cols="2")
                      v-btn.button-xs.danger700--text.px-0.underline(text @click="handleRemoveItem(selectedItem)") Remove
                  v-divider(v-if="selectedItemIdx !== selected.length - 1")

    v-divider
    v-card-actions.px-6.py-2
      v-spacer
      v-btn.button-md(:loading="isLoading" color="primary" depressed :disabled="selected.length === 0" @click="handleInsertToTreatmentPlan") Insert to treatment plan

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean
    },
    isOTC: {
      type: Boolean
    },
    inventoryOnly: {
      type: Boolean,
      default: false
    },
    allowOutOfStock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      selectedVisit: null,
      pageSize: -1,
      histories: [],
      treatments: [],
      selected: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Stock', value: 'stocks'},
        { text: 'UOM', value: 'uom' },
        { text: 'Price', value: 'price_range' },
      ],
    }
  },
  mounted () {
    this.fetchHistories(true)
  },
  watch: {},
  computed: {
    ...mapGetters({
      company: 'getCompany',
      consultation: 'treatment/getConsultation',
      patient: 'treatment/getPatient',
      hqSelectedCompany: 'hq/getSelectedCompany',
      isHq: 'hq/getIsHq'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    allDisabled () {
      return this.treatments.every(item => item.disabled)
    },
    allSelected () {
      if (this.allDisabled) {
        return false
      }
      const productIds = this.treatments.filter(item => !item.disabled).map(item => item.id)
      return this.selected.filter(item => productIds.includes(item.id)).length === productIds.length
    },
    screenHeight () {
      return window.innerHeight
    },
    treatmentTableHeight () {
      return this.screenHeight - 395
    },
    selectedItemHeight () {
      return this.screenHeight - 258 + 'px'
    }
  },
  methods: {
    fetchHistories () {
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        fields: 'lead_id,lead_pid,record_date,treatments',
        exclude_ids: this.consultation.lead
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      this.$axios.get(`/clinics/${companySlug}/patients/${this.patient.id}/histories`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.histories = resp.data.results.filter(f => f.treatments.length).map(m => {
              return {
                ...m,
                title: this.$options.filters.humanizeDate(m.record_date)
              }
            })
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    selectVisit (leadPid) {
      let treatments = this.histories.find(h => h.lead_pid === leadPid).treatments
      if (this.inventoryOnly) {
        treatments = treatments.filter(t => ['medication'].includes(t.product.type))
      }
      this.treatments = treatments.map(this.sanitizeData)
    },
    sanitizeData (item) {
      const disabled = this.isDisabled(item)
      const hasError = this.allowOutOfStock ? (item.product.type === 'documents') : this.hasError(item)
      return {
        ...item,
        uom: this.getUOM(item),
        stocks: this.getStock(item),
        disabled,
        hasError,
        errorMessage: hasError ? this.getErrorMessage(item) : null,
      }
    },
    hasStock(item) {
      if (!item.product.inventory_enabled) {
        return true
      }
      if (item.product.inventory_qty > 0) {
        return true
      }
      return false
    },
    getUOM (item) {
      return item.product.uom
    },
    getStock (item) {
      if (!item.product.inventory_enabled) {
        return null
      }
      return item.product.inventory_qty
    },
    hasError (item) {
      return item.product.type === 'documents' || this.getStock(item) === 0
    },
    getErrorMessage (item) {
      if (this.hasError(item)) {
        if (item.product.type === 'documents') return 'Medical document cannot be added for multiple bulk. Please use single add.'
        if (this.getStock(item) === 0) return 'Out of stock'
      }
      return null
    },
    isDisabled (item) {
      if (this.allowOutOfStock) return item.product.type === 'documents'
      return !this.hasStock(item) || this.hasError(item)
    },
    handleSelectAll (value) {
      if (value) {
        this.selected = [...this.selected, ...this.treatments.filter(item => !this.isDisabled(item))]
      } else {
        const productsId = this.treatments.map(item => item.id)
        this.selected = this.selected.filter(item => !productsId.includes(item.id))
      }
    },
    handleRemoveItem (item) {
      this.selected = this.selected.filter(selectedItem => selectedItem.id !== item.id)
    },
    handleRemoveAllItem () {
      this.selected = []
    },
    handleInsertToTreatmentPlan () {
      this.isLoading = true
      let selected = JSON.parse(JSON.stringify(this.selected))
      selected = selected.map(item => {
        item.id = null
        if (item.product.type === 'bundle') {
          item.bundles = item.bundles.map(m => { return { ...m, id: null } })
        }
        return item
      })
      this.$emit('insert', selected)
    }
  }
};
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid var(--v-neutral300) !important;
}
.height-adjustment {
  height: var(--selected-item-height);
}
.selected-items-container {
  height: calc(100% - 40px);
  overflow-y: auto;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var (--v-danger500);
    }
  }
  .combostyle .v-input__icon {
    min-width: 22px;
    width: 22px;
    margin-top: 4px;
  }
}
</style>